import {
    ExternalAssociation,
    LiveEvent,
    Location,
} from '@reg/shared/model';
import { BaseEvent } from '../base-event.model';

export class EventCore extends BaseEvent {
    public static APPROVAL_STATUS_NOT_LINKED: string = 'not linked';
    public static APPROVAL_STATUS_LINKED: string = 'linked';
    public location: Location;
    public siteId: number;
    public shareableLink: string;
    public externalAssociations: ExternalAssociation[] = [];
    public liveEvent: LiveEvent;
    public isLiveEvent: boolean;
    public arenaLinkedIds: string[] = [];
    public hasSalesforceLink: boolean = false;

    constructor(siteId?: number, id?: string) {
        super();
        this.id = id;
        this.siteId = siteId;
        this.timeZone = 'America/Chicago';
        this.location = new Location();
        this.approvalStatus = EventCore.APPROVAL_STATUS_NOT_LINKED;
    }

    public static getFields(): string[] {
        return [
            'data.id',
            'data.title',
            'data.start_date_time',
            'data.end_date_time',
            'data.node.external_associations',
            'data.location',
            'data.node.site.id',
            'data.timezone',
            'data.live_event',
            'data.shareable_link',
        ];
    }

    public deserialize(json: any): EventCore {
        const data: any = json.data || json;
        this.id = data.id.toString();
        this.name = data.title;
        this.startDateTime = new Date(data.start_date_time);
        this.endDateTime = new Date(data.end_date_time);
        this.timeZone = data.timezone;
        this.location = new Location().deserialize(data.location);
        this.siteId = data.node.site.id;
        this.shareableLink = data.shareable_link;
        this.isLiveEvent = !!data.live_event;
        if (data.live_event) this.liveEvent = new LiveEvent().deserialize(data.live_event);
        this.externalAssociations = (data.node.external_associations || [])
            .map((link: any) => {
                const externalAssociation = new ExternalAssociation().deserialize(link);
                if (externalAssociation.isArenaLink()) this.arenaLinkedIds.push(externalAssociation.externalId);
                if (externalAssociation.isSalesforceLink()) this.hasSalesforceLink = true;
                return externalAssociation;
            });
        return this;
    }

    // generate clone function of event
    public clone(): EventCore {
        const clone = new EventCore(this.siteId);
        clone.id = this.id;
        clone.name = this.name;
        clone.startDateTime = this.startDateTime;
        clone.endDateTime = this.endDateTime;
        clone.timeZone = this.timeZone;
        clone.location = this.location;
        clone.shareableLink = this.shareableLink;
        clone.externalAssociations = this.externalAssociations;
        clone.liveEvent = this.liveEvent;
        clone.isLiveEvent = this.isLiveEvent;
        clone.arenaLinkedIds = this.arenaLinkedIds;
        clone.approvalStatus = this.approvalStatus;
        return clone;
    }

    public isLinkedToArenaId(arenaId: string): boolean {
        return this.arenaLinkedIds.includes(arenaId);
    }
}
